// extracted by mini-css-extract-plugin
export var contentBody = "_ak-9";
export var headerImage = "_ak-2";
export var imageButton = "_ak-7";
export var imageButtonIcon = "_ak-8";
export var imageHeader = "_ak-4";
export var imageHeaderText = "_ak-5";
export var imageOverlay = "_ak-3";
export var imageTitle = "_ak-6";
export var imageWrapper = "_ak-1";
export var taskList = "_ak-a";
export var widget = "_ak-0";